<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      :submitData="submitData"
      :title="videoCategoryRenew.title"
      :id="videoCategoryRenew.id"
      :close="close"
    ></MapModal>
    <!-- {{ submitData }} -->
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");

export default {
  name: "surveil-directory-renew",
  props: { state: String, id: String, close: Function },
  components: { MapModal },
  data() {
    return {
      videoCategoryRenew: {
        title: this.state == "add" ? "添加监控点分类" : "编辑监控点分类",
        id: "videoCategoryRenew",
      },
      modalNode: {
        bimVideoCategory: {
          show: true,
          loading: false,
          // 样式配置 定位使用
          // style: "margin: 106px 0 0 -706px;",
          offset: {
            // 默认弹出层偏移
            x: 106,
            y: -706,
            // unit: "px", // 默认px
          },
          // width: "450px",
          // auto 自适应
          height: "auto",
          //模态框head配置
          head: {
            //是否能拖动
           canmove: {
           	//当前拖动状态
           	state: true,
           },
           //折叠配置
           fold: {
           	//当前折叠状态
           	state: true,
           }
          },
          //模态框中心配置
          content: {
            type: "form",
            formData: {
              parentId: {
                type: "select",
                title: "下拉框",
                disabled: false,
                options: [
                  {
                    name: "目录",
                    parentId: "-1",
                    id: "0",
                    surveilType: "directory",
                  },
                ],
              },
              name: {
                md: 24,
                type: "textarea",
                title: "文本框",
                rows: 2,
                disabled: false,
                placeholder: "请填写所属文本",
              },
              checkbox: {
                md: 24,
                type: "checkbox",
                title: "复选框",
                disabled: false,
              },
              parentId1: {
                md: 24,
                icon: "$",
                type: "input",
                title: "输入框",
                placeholder: "请输入",
              },
              // parentId2: {
              //   md: 12,
              //   type: "input",
              //   title: "所属分类",
              // },
            },
            rules: {
              parentId: [
                {
                  required: true,
                  message: "请选择",
                  trigger: "blur",
                },
              ],
              name: [
                {
                  required: true,
                  message: "请填写文本",
                  trigger: "blur",
                },
              ],
            },
          },
        },
      },
      submitData: {
        parentId: "",
        name: "",
      },
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {
    state(newName, oldName) {
      console.log(newName);
      if (newName == "add") {
        this.videoCategoryRenew.title = "添加";
        this.submitData.parentId = "";
        this.submitData.name = "";
      } else {
        this.videoCategoryRenew.title = "编辑";
      }
    },
  },
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    init() {
      console.log("初始化");
      this.modalNode.bimVideoCategory.loading = false;
    },
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
    this.init();
  },

  beforeUpdate() {
    //数据更新时调用，发生在虚拟 DOM 打补丁之前。这里适合在更新之前访问现有的 DOM，比如手动移除已添加的事件监听器。
    //该钩子在服务器端渲染期间不被调用，因为只有初次渲染会在服务端进行。
  },
  updated() {
    //由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
    //当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
    //然而在大多数情况下，你应该避免在此期间更改状态。如果要相应状态改变，通常最好使用计算属性或 watcher 取而代之。
  },
  activated() {
    //被 keep-alive 缓存的组件激活时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  deactivated() {
    //被 keep-alive 缓存的组件停用时调用。
    //该钩子在服务器端渲染期间不被调用。
  },
  beforeUnmount() {
    //实例销毁之前调用。在这一步，实例仍然完全可用。
    //该钩子在服务器端渲染期间不被调用。
  },
  unmounted() {
    //实例销毁后调用。该钩子被调用后，对应 Vue 实例的所有指令都被解绑，所有的事件监听器被移除，所有的子实例也都被销毁。
    //该钩子在服务器端渲染期间不被调用。
  },
  errorCaptured() {
    //当捕获一个来自子孙组件的错误时被调用。
    //此钩子会收到三个参数：错误对象、发生错误的组件实例以及一个包含错误来源信息的字符串。
    //此钩子可以返回 false 以阻止该错误继续向上传播。
  },
};
</script>

